import { render, staticRenderFns } from "./EmpoweringCustomer.vue?vue&type=template&id=15c69473&scoped=true&"
import script from "./EmpoweringCustomer.vue?vue&type=script&lang=js&"
export * from "./EmpoweringCustomer.vue?vue&type=script&lang=js&"
import style0 from "./EmpoweringCustomer.vue?vue&type=style&index=0&id=15c69473&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c69473",
  null
  
)

export default component.exports